import React from "react";
import { NavLink } from "react-router-dom";
import "./adminSidebar.css"; 

const AdminSidebar = () => {

   const role = localStorage.getItem("admin_role");

  return (
    <div className="admin-sidebar">
      <h2 className="sidebar-title">Admin Panel</h2>

      {role === "admin" && (
        <>
      {/* Admin Section */}
      <div className="sidebar-section">
        <h3>Admin</h3>
        <NavLink 
          to="/rc_admin_panel/domain" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Domain 
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/products" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Products
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/total_orders" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Total Orders
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/approveinternships" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Internships
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/addusers" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Add Users
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/pcbrequests" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Check Pcb Requests
        </NavLink>
        
        <NavLink 
          to="/rc_admin_panel/addmilestone" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Add MileStones
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/addgallerypage" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Add GalleryPage Images
        </NavLink>
      </div>

      {/* BDM Section */}
      <div className="sidebar-section">
        <h3>BDM</h3>
        <NavLink 
          to="/rc_admin_panel/queries" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Queries
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/questions" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Questions
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/reviews" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Reviews
        </NavLink>
      </div>

    {/*INTERNSHIP SECTION */}
      <div className="sidebar-section">
        <h3>Internships</h3>
        <NavLink 
          to="/rc_admin_panel/slots" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Slots
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/amountupdate" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Amount
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/confirminternship" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Confirm Internships
        </NavLink>

      </div>
        </>
      )}


      <div className="sidebar-section">
        <h3>Stock Control</h3>
        <NavLink 
          to="/rc_admin_panel/inventory" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Inventory Management
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/packaging" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Packaging Management
        </NavLink>
      </div>
    </div>  
  );
};

export default AdminSidebar;
